import {
    getHomeBrowsePuzzleTitle,
    getHomePuzzlePlayPath,
    getLocalizedHomeBrowseStoryTeaser,
    homeBrowseRowToCardPuzzle,
    isHomeBrowsePuzzlePublished,
} from "./homePuzzleRoUtils";
import { isWordPuzzleOpenAccess } from "../puzzles/common/puzzleTierAccess";

/**
 * Map GET `/home/puzzle` row to landing featured card meta (word puzzles).
 * Free-tier eligibility follows difficulty policy (Easy = open), not the legacy `free` flag.
 * @returns {{ playId: string, title: string, level: string, type: string, imageUrl: string | null, playPath: string, publishedAt: string | null, isFreeTier: boolean } | null}
 */
export function getHomePuzzleLandingFeaturedMeta(ro, contentLanguage) {
    if (!ro || !isHomeBrowsePuzzlePublished(ro)) return null;
    const mapped = homeBrowseRowToCardPuzzle(ro);
    if (!mapped?.puzzle) return null;
    const playPath = getHomePuzzlePlayPath(ro);
    if (!playPath) return null;

    const { storyTitle, imageUrl } = getLocalizedHomeBrowseStoryTeaser(ro, contentLanguage);
    const title = storyTitle || mapped.puzzle.title || getHomeBrowsePuzzleTitle(ro) || "—";
    const level = mapped.puzzle.difficultyLevel ?? "MEDIUM";

    return {
        playId: mapped.puzzle.id,
        title,
        level,
        type: mapped.category,
        imageUrl: imageUrl && String(imageUrl).trim() ? String(imageUrl).trim() : null,
        playPath,
        publishedAt: mapped.puzzle.publishedAt ?? null,
        isFreeTier: isWordPuzzleOpenAccess(level),
    };
}
